import menuItems from '@/menu.js'
const items = [
    ...menuItems,
    {
        name: 'Facility Owners',
        link: '/facility-owners',
        icon: ' fa fa-building'
    },
    {
        name: 'Companies',
        link: '/companies',
        icon: ' fa fa-briefcase'
    },
    {
        name: 'Pricing',
        link: '/pricing',
        icon: ' fa fa-dollar-sign'
    },
    {
        name: 'Business Categories',
        link: '/business-categories',
        icon: ' fa fa-tags'
    },
    {
        name: 'Checkout Options',
        link: '/checkout-options',
        icon: ' fa fa-shopping-cart'
    },
    {
        name: 'Customer Orders',
        link: '/customer-orders',
        icon: ' fa fa-search-dollar'
    },
    {
        name: 'Archived Locations',
        link: '/archived-locations',
        icon: ' fa fa-building'
    },
];
export default items;
